import React, { useEffect , useState } from "react";
//import axios from '../../../node_modules-back/axios';
import axios from 'axios'
//import { useForm } from '../../../node_modules-back/react-hook-form/dist';
import { useForm } from 'react-hook-form';
import { Form } from 'react-bootstrap';
import { getUrl } from "../../ApiCall/GetUrl";
import { ApiCallPost } from "../../ApiCall/ApiCall";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import Footer from "../Footer/Footer";
// Importación de los estilos
import "../../styles/LogIn.css"
//import { getPickersArrowSwitcherUtilityClass } from "@mui/x-date-pickers/internals/components/PickersArrowSwitcher/pickersArrowSwitcherClasses";

import { useNavigate , useLocation  } from "react-router-dom";

export default function LogIn() {

  const [isClient,setIsClient] = useState( null )

  const navigate = useNavigate();
  const location = useLocation() ;


  useEffect(() => {

    if ( location.state.isClient )
    {
      setIsClient( true )
    }
    else{
      setIsClient( false )
    }

  } , [])


  function onAbogadoChange( e )
  {
    console.log( "OnAbogadoChange " , e )
  }

  const {
    register,
    handleSubmit,
    clearErrors,
    control,
    formState: {
      errors
    }
  } = useForm();


  function onCrearCuenta() {

    //e.preventDefaul() ;

    console.log( "Soy Abogado ="  + document.getElementById("soyAbogado").checked)

    if ( document.getElementById("soyAbogado").checked )
    {
      navigate('/abogados' , { state : { validation : true } } )
    }
    else{
      navigate('/clientes', { state : { validation : false , isClient : location.state.isClient } })
    } 


    
    //navigate('/signup')
  }

  const onSubmit = async (data) => {
    console.log(data);
    if (data.validation) {
      console.log("Soy abogado")

      data.lawyer_email = data.mail;
      data.lawyer_password = data.password;
      data.last_login = new Date();

      //data.mail = null;
      //data.password = null;

      try {
        const response = await ApiCallPost("/lawyer_login", data);
        console.log("Respuesta del servidor: ", response)

        // try {
        //   const response = await ApiCallPost("/client", data);
        //   console.log("Respuesta del servidor: ", response)
        //   if(response.status === 0){
        //     console.log(response.message);
        //   }
        // } catch (error) {
        //   console.log("Error en la llamada: ", error);
        // }

        //console.log("Respuesta del servidor: ", response)



        switch(response.status){
          case 0: 
            //alert("Se ha ingresado correctamente");

            console.log( "Antes de lawyerdash = " , { id : response.id, name : response.name , logg_express : response.logg_express })
            //return ;

            navigate('/lawyerdash' , 
              { state : { id : response.id , name : response.name , logg_express : response.logg_express }} ) 

            return ;

            break;
          case -1: 
            alert("Hubo un error, intentelo de nuevo");
            break;
          case -2: 
            alert("Correo o contraseña incorrectos");
            break;
          case -3: 
            alert("Este correo no se encuentra en abogados");
            break;
        }
        } catch (error) {
        console.log("Error en la llamada: ", error);
      }
    } else { // Soy cliente
      console.log("Soy cliente")
      data.client_email = data.mail;
      data.client_password = data.password;
      data.last_login = new Date();

      delete(data.mail)
      delete(data.password)

      try {
        const response = await ApiCallPost("/client_login", data);
        console.log("Respuesta del servidor: ", response)

        //return ;
        // try {
        //   const response = await ApiCallPost("/client", data);
        //   console.log("Respuesta del servidor: ", response)
        //   if(response.status === 0){
        //     console.log(response.message);
        //   }
        // } catch (error) {
        //   console.log("Error en la llamada: ", error);
        // }
        switch(response.status){
          case 0: 
            //alert("Se ha ingresado correctamente");

            //navigate( "/consultaexpress")

            //console.log( "Antes de consulta = " ,  { state : { id_client : response.id, name : response.name , logg_express : response.logg_express }} )

            console.log( "Antes de logexpress " , { state : { id : response.id , name : response.name , logg_express : response.logg_express , isLawyer : document.getElementById("soyAbogado").checked }} )
            
            //return ;

            // navigate( "/agenda" , { state : { id : response.id  }} )

            if ( location.state.isClient === true )
            {
              navigate( "/agenda" , { state : { id : response.id  }} )
              return ;

            }

            navigate('/clientmenu' ,
              { state : { id : response.id , name : response.name , logg_express : response.logg_express , isLawyer : document.getElementById("soyAbogado").checked }} )


            // navigate('/consultaexpress' ,
            //     { state : { id : response.id , name : response.name , logg_express : response.logg_express , isLawyer : document.getElementById("soyAbogado").checked }} )
            break;
          case -1: 
            alert("Hubo un error, intentelo de nuevo");
            break;
          case -2: 
            alert("Correo o contraseña incorrectos");
            break;
          case -3: 
            alert("Este correo no se encuentra en clientes");
            break;
        }
        } catch (error) {
        console.log("Error en la llamada: ", error);
      }
    }

    // console.log(data)
    // if (validacionCom.val === true) {
    //   data.id_client_tipo_persona = personaMoral ? 1 : 0;
    //   // data.client_birthday = "2001-01-01";
    //   data.dTimeStamp = new Date();
    //   try {
    //     const response = await ApiCallPost("/post_client", data);
    //     console.log("Respuesta del servidor: ", response)
    //     if (response.status === 0) {
    //       alert("Se ha registrado correctamente")
    //     }
    //     try {
    //       const response = await ApiCallPost("/client", data);
    //       console.log("Respuesta del servidor: ", response)
    //     } catch (error) {
    //       console.log("Error en la llamada: ", error);
    //     }

    //   } catch (error) {
    //     console.log("Error en la llamada: ", error);
    //   }
    // }

  }

  const onError = (e) => {
    console.log("onError: ", e)
  }

  // Password
  const [showPassword, setShowPassword] = useState(false);

  const passwordVisibilityChange = () => {
    setShowPassword(!showPassword);
  }
  return <>
    <div className="mt-5 mb-5 container ">
      <h1 className="mb-5">Inicio de Sesión</h1>
      <div className="mt-5 d-flex">
        <Form onSubmit={
          handleSubmit(onSubmit, onError)
        }
          className="m-auto">
          <div className="row">
            <div className="d-flex justify-content-between align-items-center">
              <label className="label-style">Correo</label>
              {
                true && (
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="textAbogado me-2 mt-4">¿Eres abogado?</p>
                    <input className="form-check-input ml-2 check" type="checkbox" disabled={isClient} id="soyAbogado" onChange={(e) => onAbogadoChange(e)} {...register("validation",)} />
                  </div>
                )
              }

            </div>
            <input className="input-style" {...register("mail", {
              required: {
                value: true,
                message: "El correo es necesario."
              }
            })}></input>

            {errors?.mail?.type === "required" && <p className="error-msg">
              {
                errors.mail.message
              }</p>
            }
          </div>
          <div className="row">


            <label className="label-style">Contraseña</label>
            <input type={showPassword ? "text" : "password"} className="input-style password" {...register("password", {
              required: {
                value: true,
                message: "La contraseña es necesaria."
              }
            })}>

            </input>

            <button type="button" className="btn btn-outline-secondary btn-eye"
              onClick={passwordVisibilityChange}
            >
              {
                showPassword ? <AiFillEyeInvisible /> : <AiFillEye />
              } </button>
            {errors?.password?.type === "required" && <p className="error-msg">
              {
                errors.password.message
              }</p>
            }
          </div>
          <div className="row mt-4">
            <div className="col-sm-4">
              <a className="crt-account" 
               onClick={onCrearCuenta} style={{cursor:'grab'}} >Crear cuenta</a>
            </div>
            <div className="col-sm-8">
              <button className=" btn btn-primary ">Iniciar</button>
            </div>
          </div>
        </Form>
      </div>
      
    </div>
    <div className=" mt-0">
      <Footer oscuro={true}></Footer>
    </div>
  </>
}
